import { FontAwesome5 } from '@expo/vector-icons';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { capitalize } from 'lodash';
import React, { useState, useEffect } from 'react';
import {
  Pressable,
  StyleSheet,
  View,
  ActivityIndicator,
  Text,
} from 'react-native';

import Styles from '../../styles';
import Colors from '../../styles/Colors';
import { CalcVariants, Difficulties, Difficulty } from '../../types';
import { difficulties } from '../../utils';

export default function DifficultyScreen() {
  const [isLoading, setLoading] = useState(true);
  const [chosen, setChosen] = useState<CalcVariants>('plus');
  const [difficulty, setDifficulty] = useState<Difficulties>({
    plus: 'medium',
    minus: 'medium',
    times: 'medium',
    divide: 'medium',
  });

  useEffect(() => {
    const getData = async () => {
      try {
        const difficultyChoices = await AsyncStorage.getItem('Difficulty');
        if (difficultyChoices !== null) {
          setDifficulty(JSON.parse(difficultyChoices));
        }
        setLoading(false);
      } catch (e) {}
    };
    getData();
  }, []);

  useEffect(() => {
    const setData = async () => {};
    setData();
  }, [difficulty]);

  return (
    <View style={[Styles.container]}>
      {isLoading && (
        <ActivityIndicator color={Colors.buttonLight} size="large" />
      )}
      {!isLoading && (
        <>
          <View style={styles.buttonContainer}>
            <ChoiceButton
              iconName="plus"
              setChosen={setChosen}
              chosen={chosen}
            />
            <ChoiceButton
              iconName="minus"
              setChosen={setChosen}
              chosen={chosen}
            />
            <ChoiceButton
              iconName="times"
              setChosen={setChosen}
              chosen={chosen}
            />
            <ChoiceButton
              iconName="divide"
              setChosen={setChosen}
              chosen={chosen}
            />
          </View>
          <Text style={[Styles.text, styles.title]}>
            {capitalize(chosen)} difficulty
          </Text>
          <View style={styles.difficultyContiner}>
            <DifficultyButton
              name="easy"
              difficulty={difficulty}
              chosen={chosen}
              setDifficulty={setDifficulty}
            />
            <DifficultyButton
              name="medium"
              difficulty={difficulty}
              chosen={chosen}
              setDifficulty={setDifficulty}
            />
            <DifficultyButton
              name="hard"
              difficulty={difficulty}
              chosen={chosen}
              setDifficulty={setDifficulty}
            />
          </View>
        </>
      )}
    </View>
  );
}

function ChoiceButton({
  iconName,
  setChosen,
  chosen,
}: {
  iconName: CalcVariants;
  setChosen(choice: CalcVariants): void;
  chosen: CalcVariants;
}) {
  return (
    <Pressable
      onPress={() => setChosen(iconName)}
      style={[
        styles.chooseButton,
        Styles.btn,
        {
          backgroundColor:
            chosen === iconName ? Colors.buttonLight : Colors.buttonDark,
        },
      ]}
    >
      <FontAwesome5 name={iconName} color="white" size={60} />
    </Pressable>
  );
}

function DifficultyButton({
  name,
  difficulty,
  chosen,
  setDifficulty,
}: {
  name: Difficulty;
  difficulty: Difficulties;
  chosen: CalcVariants;
  setDifficulty(difficulty: Difficulties): void;
}) {
  const [isSaving, setSaving] = useState(false);
  return (
    <Pressable
      style={[
        styles.difficultyButton,
        Styles.btn,
        {
          backgroundColor:
            name === difficulty[chosen]
              ? Colors.buttonLight
              : Colors.buttonDark,
        },
      ]}
      onPress={async () => {
        setSaving(true);
        const newDifficulty = { ...difficulty, [chosen]: name };
        try {
          await AsyncStorage.setItem(
            'Difficulty',
            JSON.stringify(newDifficulty)
          );
        } catch (e) {}
        setDifficulty(newDifficulty);
        setSaving(false);
      }}
    >
      {isSaving && (
        <ActivityIndicator color={Colors.buttonLight} size="large" />
      )}
      {!isSaving && (
        <>
          <Text style={[Styles.text, { fontSize: 30 }]}>
            {capitalize(name)}
          </Text>
          <Text style={[Styles.text]}>
            From {difficulties[chosen][name]['min']}{' '}
            <FontAwesome5 name={chosen} size={10} />{' '}
            {difficulties[chosen][name]['min']} to{' '}
            {difficulties[chosen][name]['max']}{' '}
            <FontAwesome5 name={chosen} size={10} />{' '}
            {difficulties[chosen][name]['max']}
          </Text>
        </>
      )}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  chooseButton: {
    height: 80,
    width: 80,
    borderRadius: 15,
  },
  difficultyButton: {
    height: 100,
    width: '80%',
    borderRadius: 15,
  },
  buttonContainer: {
    width: '95%',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  difficultyContiner: {
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  title: {
    fontSize: 40,
  },
});
